import { IAppState } from '../../store';

export const selectPageData = (state: IAppState) => state.pageData;
